import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { http } from "@/lib/http";

const Ctx = createContext(null);
const DONE_KEY = "mh-guide-done";

export const matchModule = (modules, pathname) => {
  const hits = modules.filter((m) => m.path && (m.path === "/" ? pathname === "/" : m.path.endsWith("/") ? pathname.startsWith(m.path) && pathname !== m.path.slice(0, -1) : pathname === m.path || (m.also || []).includes(pathname)));
  return hits.sort((a, b) => b.path.length - a.path.length)[0] || null;
};

export function GuideProvider({ children }) {
  const [guide, setGuide] = useState(null);
  const [open, setOpen] = useState(false);
  const [tab, setTab] = useState("page");
  const [moduleId, setModuleId] = useState(null);
  const [tour, setTour] = useState(null);
  const [done, setDone] = useState(() => JSON.parse(localStorage.getItem(DONE_KEY) || "[]"));
  const nav = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => { http.get("/guide").then((r) => setGuide(r.data)).catch(() => {}); }, []);
  const markDone = useCallback((id) => setDone((d) => { const n = d.includes(id) ? d : [...d, id]; localStorage.setItem(DONE_KEY, JSON.stringify(n)); return n; }), []);
  const startTour = useCallback((m) => {
    setOpen(false);
    const concrete = m.path && !m.path.endsWith("/");
    if (concrete && pathname !== m.path) nav(m.path);
    setTimeout(() => setTour({ module: m, i: 0 }), concrete && pathname !== m.path ? 700 : 150);
  }, [nav, pathname]);
  const openGuide = useCallback((t = "page", id = null) => { setTab(t); setModuleId(id); setOpen(true); }, []);
  const current = useMemo(() => (guide ? matchModule(guide.modules, pathname) : null), [guide, pathname]);
  const value = { guide, open, setOpen, tab, setTab, moduleId, setModuleId, tour, setTour, startTour, openGuide, current, done, markDone, pathname };
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export const useGuide = () => useContext(Ctx);
